import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

const Fexatitle = () => {
    useEffect(() => {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let interval = null;

        const h2Element = document.querySelector("h2");
        const handleMouseOver = () => {
            let iteration = 0;

            clearInterval(interval);

            interval = setInterval(() => {
                const lettersArray = h2Element.dataset.value.split("");
                const newLettersArray = lettersArray.map((letter, index) => {
                    if (index === iteration) {
                        return `<span class="white-letter">${letters[Math.floor(Math.random() * 26)]}</span>`;
                    }
                    return letter;
                });

                h2Element.innerHTML = newLettersArray.join("");

                if (iteration >= h2Element.dataset.value.length) {
                    clearInterval(interval);
                }

                iteration++;
            }, 50);
        }

        // Call the function immediately to run the effect on first render
        setTimeout( () => {
            handleMouseOver();
        }, 1000);


    }, []);

    return (
        <div>
            <div>
                <h2 className="heading_b" data-value="Fexaop Projects">Fexaop Projects</h2>
                <a href="/project">
                    <FontAwesomeIcon  className="icon_b" icon={faArrowRight}  />
                </a>
            </div>
        </div>
    );
};

export default Fexatitle;